import { useEffect } from "react";
import Cookies from "js-cookie";

const AuthGate = () => {
  useEffect(() => {
    const token = Cookies.get("token");

    if (!token) {
      window.location.assign("https://app.pdf.co/login");
    }
  }, []);

  return null;
};

export default AuthGate;


